import { GetWorkSpaceDocument, GetWorkSpaceQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkSpace = NonNullable<GetWorkSpaceQuery['spaceControl']['workSpace']>

export const useWorkSpace = (id: string) => {
  const { loading, data } = useQuery(GetWorkSpaceDocument, { variables: { id } })

  return {
    loading,
    workSpace: data ? data.spaceControl.workSpace : undefined,
  }
}
